import React from 'react';
import { SearchBillingProfilesTable } from '@css-xp/ppc-billing-profile-table';
import { fetchResourceIdsFromContact, ResourceContact } from '@css-xp/contact-resources';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';

interface Props {
  searchTerm: string;
  partnerSearchContext: string;
  transactionAccountId: string;
  shouldHideInnerHeading?: boolean;
  isDesignIteration1Enabled?: boolean;
}

export const BillingProfilesSearchByCustomerContact: React.FC<Props> = ({
  transactionAccountId,
  searchTerm,
  shouldHideInnerHeading,
  isDesignIteration1Enabled,
}) => {
  const { loading, error, data } = usePersistedCacheQuery(fetchResourceIdsFromContact, {
    variables: {
      contactEmail: searchTerm,
      contactType: ['CUSTOMER_CONTACT'],
      transactionAccountId,
    },
  });

  const invoiceGroupIds =
    (data?.resourcesByContact as ResourceContact[])
      ?.filter((resourceDetails) => resourceDetails?.resourceType === 'invoice-group')
      ?.map((resourceDetails) => resourceDetails.resourceId)
      .filter(Boolean) ?? [];

  return (
    <SearchBillingProfilesTable
      transactionAccountId={transactionAccountId}
      invoiceGroupIds={invoiceGroupIds}
      label={'Billing Profiles'}
      parentDataLoading={loading}
      testIdSuffix={'by-customer-contact'}
      shouldHideInnerHeading={shouldHideInnerHeading}
      isDesignIteration1Enabled={isDesignIteration1Enabled}
    />
  );
};
